import App from 'app/app.js';
import 'app/action/ResetJobAction.js';

function DigitalDownloadStore($http, $q, ResetJobAction) {
  var termsConditionsFlag = false,
    digitalDownloadCollection = {},
    imageAuthorization = {};

  this.clearAll = function () {
    termsConditionsFlag = false;
    digitalDownloadCollection = {};
    imageAuthorization = {};
  };

  this.loadDigitalDownLoads = function (identifier) {
    var dfd = $q.defer(),
      url = 'digitalDownload/load/' + identifier;

    this.clearAll();
    $http
      .get(url)
      .then(
        function (response) {
          if (!response.data.success) {
            dfd.reject(response.data.error);
          } else {
            digitalDownloadCollection = response.data.data.digitalDownloadCollection;
            imageAuthorization = response.data.data.imageAuthorization || {};
            dfd.resolve();
          }
        }.bind(this)
      )
      .catch(function () {
        dfd.reject('DIG_DOWNLOAD_FAIL_GENERIC_MESSAGE');
      });
    return dfd.promise;
  };

  this.getDigitalDownLoads = function () {
    return digitalDownloadCollection;
  };

  this.getBearerTokenURL = function () {
    return imageAuthorization.bearerTokenURL;
  };

  this.getTermsConditionsFlag = function () {
    return termsConditionsFlag;
  };

  this.setTermsConditionsFlag = function (value) {
    termsConditionsFlag = value;
  };

  this.canDownload = function () {
    return !!digitalDownloadCollection.digitalDownloads && termsConditionsFlag;
  };

  ResetJobAction.register(this.clearAll.bind(this));
}

App.service('DigitalDownloadStore', ['$http', '$q', 'ResetJobAction', DigitalDownloadStore]);
